<template>
  <div>
    <v-layout>
      <template>
        <v-btn
            v-if="pendingDriverApplicationCount > 0"
            small
            elevation="0"
            light
            color="purple"
            class="ml-1 text-capitalize"
            @click="gotoApplicationPage"
            style="color: white;"
        >
          Pending Application: {{pendingDriverApplicationCount}}
        </v-btn>
      </template>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "PendingApplicationCount",
  data: {

  },
  computed: {
    pendingDriverApplicationCount: function () {
      return this.$store.getters.getPendingDriverApplicationCount;
    },
  },
  methods: {
    gotoApplicationPage() {
      this.$router.push("/drivers/applications");
    },
  }
}
</script>

<style scoped>

.list-item-height {
  min-height: 28px !important;
}

</style>